import React from 'react'
import SignInHeader from '../../components/signIn/SignInHeader';
import Footer from '../../common/Footer/Footer';
import TherapistSignInForm from '../../components/SigninTherapist/TherapistSinginForm';
import TherapistSignInFooter from '../../components/SigninTherapist/TherapistSigninFooter'
import CookieBanner from '../../components/CookieBanner/CookieBanner'
import SEO from '../../components/SEO/SEO'


function SignInTherapist() {
    return (
        <>
          <SEO title="Therapist Sign In" noIndex={true} />
          <div className="block md:hidden">
       
          </div>
    
          <div className="flex justify-center items-center min-h-screen notranslate" translate="no">
            <div className="bg-tertiary rounded-[50px] mb-32 p-6 sm:p-8 shadow-lg w-full max-w-[95%] md:max-w-[1039px] h-auto relative">
              <SignInHeader />
              <TherapistSignInForm />
              <TherapistSignInFooter />
            </div>
          </div>
          <div>
            <Footer />
          </div>
          <CookieBanner />
        </>
      );
    };

export default SignInTherapist